module.exports = __webpack_public_path__ + "img/low-fat-jambalaya.d23a1e6a.jpg";